export default "__VITE_ASSET__CsEFijsl__"